export const validateOnlyInteger = (value: string | number): string | boolean =>
  Number.isInteger(+value) || 'Only integers';
